(function () {
  function money(c, fmt) {
    fmt = fmt || '${{amount}}';
    var n = c / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function init(root, data) {
    var form = root.querySelector('.np-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var spInput = form.querySelector('input[name="selling_plan"]');
    var subT = form.querySelector('.np-sub-toggle');
    var priceEl = form.querySelector('[data-np-price]');
    var btn = form.querySelector('.np-atc');
    var busy = false;
    var update = function () {
      var v = data.v[idInput.value];
      if (!v) return;
      var useSub = !!(subT && subT.checked && v.sp);
      spInput.disabled = !useSub;
      spInput.value = useSub ? v.sp.id : '';
      priceEl.textContent = money(useSub ? v.sp.p : v.p, data.money);
      btn.disabled = busy || !v.a;
    };
    root.querySelectorAll('.np-tier input').forEach(function (r) {
      r.addEventListener('change', function () {
        root.querySelectorAll('.np-tier').forEach(function (t) { t.classList.remove('is-active'); });
        r.closest('.np-tier').classList.add('is-active');
        idInput.value = r.value;
        update();
        try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState({}, '', u.toString()); } catch (e) {}
      });
    });
    if (subT) subT.addEventListener('change', update);
    update();

    var sd = root.querySelector('[data-np-shipdate]');
    if (sd) {
      var d = new Date();
      d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      sd.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      busy = true;
      btn.classList.add('is-loading');
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { alert(res.description || res.message || 'Could not add to cart'); return; }
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = base + 'cart';
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { busy = false; btn.classList.remove('is-loading'); update(); });
    });

    var track = root.querySelector('.np-gal__track');
    var thumbs = root.querySelectorAll('.np-gal__thumb');
    if (!track) return;
    var slides = function () { return track.children; };
    var cur = function () {
      var c = slides(), best = 0, bd = Infinity;
      for (var i = 0; i < c.length; i++) {
        var d = Math.abs(c[i].offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    };
    var go = function (i) {
      var c = slides(), n = c.length;
      i = (i + n) % n;
      track.scrollTo({ left: c[i].offsetLeft - c[0].offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-i')); }); });
    var pv = root.querySelector('.np-gal__arrow--prev');
    var nx = root.querySelector('.np-gal__arrow--next');
    if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
    var strip = root.querySelector('.np-gal__thumbs');
    var tp = root.querySelector('.np-gal__thumbarrow--prev');
    var tn = root.querySelector('.np-gal__thumbarrow--next');
    if (strip && tp) tp.addEventListener('click', function () { strip.scrollBy({ left: -216, behavior: 'smooth' }); });
    if (strip && tn) tn.addEventListener('click', function () { strip.scrollBy({ left: 216, behavior: 'smooth' }); });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var c = cur();
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === c); });
        var a = thumbs[c];
        if (a && a.parentNode.scrollWidth > a.parentNode.clientWidth) a.parentNode.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' });
      }, 80);
    });
  }
  function boot() {
    document.querySelectorAll('.np-pdp').forEach(function (root) {
      var el = document.getElementById('np-data-' + root.id.replace('np-pdp-', ''));
      if (!el || root.getAttribute('data-np-init')) return;
      root.setAttribute('data-np-init', '1');
      try { init(root, JSON.parse(el.textContent)); } catch (e) { console.error('np-pdp', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();